var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"l-blankPage"},[_c('img',{attrs:{"src":"/img/doc.svg","alt":""}}),_c('p',{staticClass:"mt25"},[_vm._v("目前尚無資料")])])
}]

export { render, staticRenderFns }